import { BaseApiService } from './BaseApiService';
import { sortById } from './utils';

export class LegislationService extends BaseApiService {
  constructor() {
    super();
    this.api = this.instance;
  }

  /**
   * `GET` /api/legislations/regulations?category_id={category_id}&year_id={year_id}&act_id={act_id}&lang_id={lang_id}
   * @param {*} categoryId
   * @param {*} actId
   * @param {*} yearId
   * @returns
   */
  async regulations(categoryId, yearId, actId) {
    const { data } = await this.api.get(`/legislations/regulations`, {
      params: {
        category_id: actId ? undefined : categoryId,
        year_id: actId ? undefined : yearId,
        act_id: actId,
      },
    });

    if (!data || !data.length) return { data: [] };

    return {
      data: data.map(x => ({
        id: x.id,
        title: x.title,
        description: x.description,
        url: x.pdf_path,
        date: x.published_at,
      })),
    };
  }

  /**
   * `GET` /api/legislations/acts?category_id={category_id}&year_id={year_id}&regulation_id={regulation_id}&lang_id={lang_id}
   * @param {*} categoryId
   * @param {*} actId
   * @param {*} yearId
   * @returns
   */
  async acts(categoryId, yearId, regulationId) {
    const { data } = await this.api.get('/legislations/acts', {
      params: {
        category_id: regulationId ? undefined : categoryId,
        year_id: regulationId ? undefined : yearId,
        regulation_id: regulationId,
      },
    });

    if (!data || !data.length) return { data: [] };

    return {
      data: data.map(x => ({
        id: x.id,
        title: x.title,
        description: x.description,
        url: x.pdf_path,
        date: x.published_at,
      })),
    };
  }

  /**
   * `GET` ​/api​/reports​/categories?lang_id={lang_id}
   * @returns
   */
  async categories() {
    const categoryIconById = {
      0: 'Legislation/Generic',
      1: 'Legislation/Organizimi dhe Shërbimet Publike',
      2: 'Legislation/Menaxhimi Financiar Publik',
      3: 'Legislation/Shërbimet dhe përkujdesja shoqërore',
      4: 'Legislation/Arsimi, sportet dhe shërbimet argetuese',
      5: 'Legislation/Mjedisi dhe Burimet Natyrore',
      6: 'Legislation/Siguria Publike',
    };

    const response = await this.api.get('/legislations/categories');

    const data = response.data
      .map(cat => ({
        ...cat,
        icon: categoryIconById[cat.id] || categoryIconById[0],
      }))
      .sort(sortById);

    return {
      ...response,
      data,
    };
  }

  async regulationYears(categoryId) {
    const { data: items } = await this.api.get(
      '/legislations/years/regulations',
      {
        params: {
          category_id: categoryId,
        },
      },
    );

    const data = items.map(item => ({
      value: item.id,
      description: item.year,
    }));

    return { data };
  }

  async actYears(categoryId) {
    const { data: items } = await this.api.get('/legislations/years/acts', {
      params: {
        category_id: categoryId,
      },
    });

    const data = items.map(item => ({
      value: item.id,
      description: item.year,
    }));

    return { data };
  }
}
